import { Component } from '@angular/core';

@Component({
  selector: 'app-valide-cmd-fourn',
  templateUrl: './valide-cmd-fourn.component.html',
  styleUrls: ['./valide-cmd-fourn.component.scss']
})
export class ValideCmdFournComponent {}
